
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft7 as ObiWindShaft7Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-7.js';
 
 
 

 
 export const ObiWindShaft7 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-7',
   elementClass: ObiWindShaft7Element,
   events: {
     
   }
  });
 
 